export default __webpack_public_path__ + "static/media/SndLowerYSlideDown2.83c43f6e.mp3";